import { client } from "../../../api/client";

export const uploadOpportunityFiles = async (files) => {
    if (process.env.REACT_APP_USELOCALDATA === "true") {
    } else {
        try {
            const response = await client.post(process.env.REACT_APP_GATEWAY_URI, `sharepointapi/opportunity/files`, files);
            return response;
        } catch (error) {
            console.error("Error uploading opportunity files:", error);
            return [];
        }
    }
}

export const uploadOpportunityFolders = async (folders) => {
    if (process.env.REACT_APP_USELOCALDATA === "true") {
    } else {
        try {
            const response = await client.post(process.env.REACT_APP_GATEWAY_URI, `sharepointapi/opportunity/folders`, folders);
            return response;
        } catch (error) {
            console.error("Error uploading opportunity files:", error);
            return [];
        }
    }
}

export const createOpportunityFolder = async (sharepoint, folderName, folderDir) => {
    if (process.env.REACT_APP_USELOCALDATA === "true") {
    } else {
        try {
            const response = await client.post(process.env.REACT_APP_GATEWAY_URI, `sharepointapi/opportunity/createfolder?sharepointUri=${sharepoint}&folderName=${folderName}&folderDir=${folderDir}`);
            return response;
        } catch (error) {
            console.error("Error creating opportunity folder:", error);
            return [];
        }
    }
}

export const updateOpportunityItemName = async (sharepoint, newName, originalItemId, folderDir) => {
    if (process.env.REACT_APP_USELOCALDATA === "true") {
    } else {
        try {
            const response = await client.post(process.env.REACT_APP_GATEWAY_URI, `sharepointapi/opportunity/updatename?sharepointUri=${sharepoint}&newName=${newName}&originalItemId=${originalItemId}&folderDir=${folderDir}`);
            return response;
        } catch (error) {
            console.error("Error updating opportunity item:", error);
            return [];
        }
    }
}

export const deleteOpportunityItem = async (sharepoint, id, folderDir) => {
    if (process.env.REACT_APP_USELOCALDATA === "true") {
    } else {
        try {
            const response = await client.delete(process.env.REACT_APP_GATEWAY_URI, `sharepointapi/opportunity?sharepointUri=${sharepoint}&id=${id}&folderDir=${folderDir}`);
            return response;
        } catch (error) {
            console.error("Error deleting opportunity item:", error);
            return [];
        }
    }
}

export const fetchOpportunityFilesData = async (sharepoint, folderDir, filters, opportunityId) => {
    if (process.env.REACT_APP_USELOCALDATA === "true") {
        try {
            const response = await client.post('https://localhost:5701/', `sharepointapi/opportunity?sharepointUri=${sharepoint}&folderDir=${folderDir}&opportunityId=${opportunityId}`, filters);
            return response.data;
        } catch (error) {
            console.error("Error fetching opportunity files:", error);
            return [];
        }
    } else {
        try {
            const response = await client.post(process.env.REACT_APP_GATEWAY_URI, `sharepointapi/opportunity?sharepointUri=${sharepoint}&folderDir=${folderDir}&opportunityId=${opportunityId}`, filters);
            console.log("response", response);
            if (response.ok)
                return response.data;
            else
                return false;
        } catch (error) {
            console.error("Error fetching opportunity files:", error);
            return [];
        }
    }
}

export const fetchOpportunityData = async (filter) => {
    if (process.env.REACT_APP_USELOCALDATA === "true") {
        const data = require("./_local/_opportunityData.json");
        return Promise.resolve(data); // ensure it's treated as async
    } else {
        try {
            const response = await client.post(process.env.REACT_APP_GATEWAY_URI, "salesforceapi/opportunities", filter);
            if (response.ok)
                return response.data;
            else
                return {data: [], totalRecords: 0};
        } catch (error) {
            console.error("Error fetching opportunities:", error);
            return {data: [], totalRecords: 0};
        }
    }
}

export const fetchOpportunitiesDropdownData = async () => {
    if (process.env.REACT_APP_USELOCALDATA === "true") {
        const data = require("./_local/_opportunityData.json");
        return Promise.resolve(data); // ensure it's treated as async
    } else {
        try {
            const response = await client.get(process.env.REACT_APP_GATEWAY_URI, "salesforceapi/opportunities/dropdown");
            if (response.ok) {
                console.log("opportunityDropdownData", response.data);
                return response.data;
            }
            else
                return [];
        } catch (error) {
            console.error("Error fetching opportunities dropdown:", error);
            return [];
        }
    }
}

export const fetchOpportunityAccountData = async (search) => {
    if (process.env.REACT_APP_USELOCALDATA === "true") {
        let data = require("./_local/_opportunityAccountData.json");
        if (search)
            data = data.filter(f => f.Id === search || f.Name === search || f.AccountNumber === search);
        return Promise.resolve(data); // ensure it's treated as async
    } else {
        try {
            const response = await client.get(process.env.REACT_APP_GATEWAY_URI, `salesforceapi/accounts${search ? `?search=${search}` : ''}`);
            if (response.ok)
                return response.data;
            else
                return [];
        } catch (error) {
            console.error("Error fetching opportunity accounts:", error);
            return [];
        }
    }
}

export const fetchSalesforceFields = async (objectName) => {
    try {
        const response = await client.get(process.env.REACT_APP_GATEWAY_URI, `salesforceapi/${objectName}/GetFields`);
        if (response.ok)
            return response.data;
        else
            return [];
    } catch (error) {
        console.error("Error fetching opportunity fields:", error);
        return [];
    }
}

export const fetchOpportunityUserData = async (search) => {
    if (process.env.REACT_APP_USELOCALDATA === "true") {
        const data = require("./_local/_opportunityUserData.json");
        return Promise.resolve(data); // ensure it's treated as async
    } else {
        try {
            const response = await client.get(process.env.REACT_APP_GATEWAY_URI, `salesforceapi/users${search ? `?search=${search}` : ''}`);
            if (response.ok)
                return response.data;
            else
                return [];
        } catch (error) {
            console.error("Error fetching opportunity users:", error);
            return [];
        }
    }
}

export const fetchOpportunityStageNames = async () => {
    if (process.env.REACT_APP_USELOCALDATA === "true") {
        try {
            const data = require("./_local/_opportunityStageNamesData.json");
            return Promise.resolve(data); // ensure it's treated as async
        } catch (error) {
            console.error("Error fetching opportunity stage names:", error);
            return [];
        }
    } else {
        try {
            const response = await client.get(process.env.REACT_APP_GATEWAY_URI, `salesforceapi/opportunityStageName`);
            if (response.ok)
                return response.data;
            else
                return [];
        } catch (error) {
            console.error("Error fetching opportunity stage names:", error);
            return [];
        }
    }
}

export const fetchOpportunityById = async (id) => {
    if (process.env.REACT_APP_USELOCALDATA === "true") {
        try {
            const data = require("./_local/_opportunityData.json");
            return Promise.resolve(data.data[0]); // ensure it's treated as async
        } catch (error) {
            console.error("Error fetching opportunity:", error);
            return undefined;
        }
    } else {
        try {
            const response = await client.get(process.env.REACT_APP_GATEWAY_URI, `salesforceapi/opportunities?id=${id}`);
            return response.data; // the response is an object with 2 attributes: records and fieldDefinition
        } catch (error) {
            console.error("Error fetching opportunity:", error);
            return undefined;
        }
    }
}

export const fetchSalesforceRLECCodes = async () => {
    if (process.env.REACT_APP_USELOCALDATA === "true") {
        try {
            return require("./_local/_opportunitySalesforceRLECCodes.json");
        } catch (error) {
            console.error("Error fetching salesforce codes:", error);
            return [];
        }
    } else {
        try {
            const response = await client.get(process.env.REACT_APP_GATEWAY_URI, `salesforceapi/opportunities/salesforcecodes`);
            if (response.ok) return response;
            else return [];
        } catch (error) {
            console.error("Error fetching opportunity:", error);
            return [];
        }
    }
}

export const updateOpportunityFields = async (opportunityId, nameValuePairs) => {
    if (process.env.REACT_APP_USELOCALDATA === "true") {
    } else {
        try {
            const response = await client.put(process.env.REACT_APP_GATEWAY_URI, `salesforceapi/opportunities/${opportunityId}/updatevalues`, nameValuePairs);
            return (response.data);
        } catch (error) {
            console.error("Error updating opportunity item:", error);
            return false;
        }
    }
}

export const fetchiQuoteByQuoteNumber = async (quoteNumber) => {
    if (process.env.REACT_APP_USELOCALDATA === "true") {
        try {
            const data = require("./_local/_iQuoteData.json");
            return Promise.resolve(data.data); // ensure it's treated as async
        } catch (error) {
            console.error("Error fetching iQuote by quote number:", error);
            return [];
        }
    } else {
        try {
            const response = await client.get(process.env.REACT_APP_GATEWAY_URI, `salesforceapi/iquotes?quoteNumber=${quoteNumber}`);            
            return response.data; // the response is an object with 2 attributes: records and fieldDefinition
        } catch (error) {
            console.error("Error fetching iQuote by quote number:", error);
            return [];
        }
    }
}

export const updateiQuoteFields = async (opportunityId, nameValuePairs) => {
    if (process.env.REACT_APP_USELOCALDATA === "true") {
    } else {
        try {
            const response = await client.put(process.env.REACT_APP_GATEWAY_URI, `salesforceapi/iquotes/${opportunityId}/updatevalues`, nameValuePairs);
            return (response.data);
        } catch (error) {
            console.error("Error updating iQuote item:", error);
            return false;
        }
    }
}

export const fetchSingleOpportunity = async (id) => {
    if (process.env.REACT_APP_USELOCALDATA === "true") {
        try {
            const data = require("./_local/_opportunityData.json");
            return Promise.resolve(data.data[0]); // ensure it's treated as async
        } catch (error) {
            console.error("Error fetching opportunity:", error);
            return [];
        }
    } else {
        try {
            const response = await client.get(process.env.REACT_APP_GATEWAY_URI, `salesforceapi/opportunities/singleOpportunity?id=${id}`);
            return response.data;
        } catch (error) {
            console.error("Error fetching opportunity:", error);
            return [];
        }
    }
}

export const fetchSingleAccount = async (id) => {
    if (process.env.REACT_APP_USELOCALDATA === "true") {
        try {
            const data = require("./_local/_opportunityAccountData.json");
            return Promise.resolve(data.data[0]); // ensure it's treated as async
        } catch (error) {
            console.error("Error fetching opportunity:", error);
            return [];
        }
    } else {
        try {
            const response = await client.get(process.env.REACT_APP_GATEWAY_URI, `salesforceapi/accounts/singleAccount?id=${id}`);
            return response.data;
        } catch (error) {
            console.error("Error fetching account:", error);
            return [];
        }
    }
}